const styles = (theme) => ({
  root: {
    display: 'inline-flex',
    flexGrow: 0,
    flexBasis: '320px',
    [theme.breakpoints.up('md')]: {
      flexBasis: '275px',
    },
  },
  drawer: {
    background: '#ff0000',
  },
  desktopMenu: {
    height: '100%',
    width: '100%',
  },
  drawerPaper: {
    borderRight: 'none',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      marginTop: '163px',
    },
  },
  name: {
    fontSize: '1.5rem',
    fontWeight: 600,
    padding: '16px 0 16px 31px',
    width: '306px',
  },
  header: {
    margin: '10px 10px 0px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  logoContainer: {
    display: 'inline-block',
    marginLeft: `-${theme.spacing.unit * 2}px`,
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  logo: {
    width: 'auto',
    height: 40,
  },
  logoutButton: {
    fontSize: '1.25rem',
    marginTop: '15px',
  },
  closeMenuButton: {
    color: theme.palette.primary.dark,
    borderRight: `1px solid ${theme.palette.border.light}`,
    borderRadius: 0,
    '& svg': {
      fontSize: '30px',
    },
  },
});

export default styles;
